import $ from 'jquery';
import carousels from '../framework/carousel';

if ($('#episodes-slider').length) {
  const episodesSlider = carousels('[data-carousel="episodes-slider"]', {
    autoplay: false,
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $('img[data-video]').on('click', (event) => {
    const $placeholderImg = $(event.currentTarget);
    const youtubeID = $(event.currentTarget).data('video');
    const $playIcon = $(`#play-icon-${youtubeID}`);
    const iframeHTML = `
    <div class="u--embed-responsive">
      <iframe
        data-play-state="stopped"
        class="episode__iframe" 
        src="https://www.youtube.com/embed/${youtubeID}?autoplay=1" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>
    `;

    $placeholderImg.replaceWith(iframeHTML);
    $playIcon.hide();
  });

  $(document).on('click', '.episode__play-icon', (event) => {
    event.stopPropagation();
    const $playIcon = $(event.currentTarget);
    const episodeId = $playIcon.attr('id').split('-')[2];
    const $iframePlayer = $(`episode-iframe-${episodeId}`);
    const playerState = $iframePlayer.data('play-state');

    if (playerState === 'playing') {
      $playIcon.show();
      $iframePlayer.attr('date-play-state', 'stopped');
      callPlayer(`episode-iframe-${episodeId}`, 'stopVideo');
    } else {
      $playIcon.hide();
      $iframePlayer.attr('date-play-state', 'playing');
      callPlayer(`episode-iframe-${episodeId}`, 'playVideo');
    }
  });
}

/**
 * @author       Rob W <gwnRob@gmail.com>
 * @website      https://stackoverflow.com/a/7513356/938089
 * @version      20190409
 * @description  Executes function on a framed YouTube video (see website link)
 *               For a full list of possible functions, see:
 *               https://developers.google.com/youtube/js_api_reference
 * @param String frame_id The id of (the div containing) the frame
 * @param String func     Desired function to call, eg. "playVideo"
 *        (Function)      Function to call when the player is ready.
 * @param Array  args     (optional) List of arguments to pass to function func*/
function callPlayer(frame_id, func, args) {
  if (window.jQuery && frame_id instanceof jQuery)
    frame_id = frame_id.get(0).id;
  var iframe = document.getElementById(frame_id);
  if (iframe && iframe.tagName.toUpperCase() != 'IFRAME') {
    iframe = iframe.getElementsByTagName('iframe')[0];
  }
  if (iframe) {
    // Frame exists,
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: func,
        args: args || [],
        id: frame_id
      }),
      '*'
    );
  }
}
